class TiptapContentResolver {
  // eslint-disable-next-line no-useless-constructor
  constructor(id, resolve) {
    this.id = id;
    this.resolve = resolve;
  }
  static create(id, resolve) {
    return new TiptapContentResolver(id, resolve);
  }
}
export {
  TiptapContentResolver
};
//# sourceMappingURL=ContentResolver.js.map
